import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../redux-store";

type FoldingState = "expanded" | "collapsed" | null;

const compactRoutesFoldingSlice = createSlice({
  name: "compactRoutesFolding",
  initialState: null as FoldingState,
  reducers: {
    setFolding: (_state, action: PayloadAction<FoldingState>) => action.payload,
  },
});

export const { setFolding } = compactRoutesFoldingSlice.actions;
export const selectCompactRoutesFolding = (state: RootState) =>
  state.compactRoutesFolding;
export default compactRoutesFoldingSlice.reducer;
